export const environment = {
  production: true,
  useEmulators: false, // Never use emulators in production
  firebaseConfig: {
    apiKey: "AIzaSyDMgBzSvSZeiluz_w5JgQjrKgIctXlv_u8",
    authDomain: "gno-knews.firebaseapp.com",
    projectId: "gno-knews",
    storageBucket: "gno-knews.firebasestorage.app",
    messagingSenderId: "524909886630",
    appId: "1:524909886630:web:f86cce3ceab740d1ad0867"
  }
};
